/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Subtitle_Exported_MessageInputs */



/**
* | output |
* | --- |
* | "Subtitle exported successfully" |
*
* @param {Iframe_Remote_Subtitle_Exported_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_exported_message = /** @type {((inputs?: Iframe_Remote_Subtitle_Exported_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_Exported_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titres exportes avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel erfolgreich exportiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitolo esportato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры успешно экспортированы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulo exportado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕导出成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕のエクスポートに成功しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक सफलतापूर्वक निर्यात हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legenda exportada com sucesso")
	return /** @type {LocalizedString} */ ("Subtitle exported successfully")
});